import APIManager from "../../ApiManager/ApiManager";

// Action types
export const FETCH_APPLICATIONS_REQUEST = "FETCH_APPLICATIONS_REQUEST";
export const FETCH_APPLICATIONS_SUCCESS = "FETCH_APPLICATIONS_SUCCESS";
export const FETCH_APPLICATIONS_FAILURE = "FETCH_APPLICATIONS_FAILURE";
export const FETCH_ALL_COUNTS_REQUEST = "FETCH_ALL_COUNTS_REQUEST";
export const FETCH_ALL_COUNTS_SUCCESS = "FETCH_ALL_COUNTS_SUCCESS";
export const FETCH_ALL_COUNTS_FAILURE = "FETCH_ALL_COUNTS_FAILURE";
export const LOAD_INITIAL_DATA_REQUEST = "LOAD_INITIAL_DATA_REQUEST";
export const LOAD_INITIAL_DATA_SUCCESS = "LOAD_INITIAL_DATA_SUCCESS";
export const LOAD_INITIAL_DATA_FAILURE = "LOAD_INITIAL_DATA_FAILURE";
export const DELETE_APPLICATION_REQUEST = "DELETE_APPLICATION_REQUEST";
export const DELETE_APPLICATION_SUCCESS = "DELETE_APPLICATION_SUCCESS";
export const DELETE_APPLICATION_FAILURE = "DELETE_APPLICATION_FAILURE";
export const REJECT_DELETE_REQUEST = "REJECT_DELETE_REQUEST";
export const REJECT_DELETE_SUCCESS = "REJECT_DELETE_SUCCESS";
export const REJECT_DELETE_FAILURE = "REJECT_DELETE_FAILURE";

// Fetch applications by status
export const fetchApplicationsByStatus = (status) => async (dispatch) => {
  dispatch({ type: FETCH_APPLICATIONS_REQUEST });

  console.log("🔵 fetchApplicationsByStatus - Status:", status);
  
  try {
    const applications = await APIManager.getAllApplication(status);
    console.log("🟢 fetchApplicationsByStatus - Response:", applications);
    
    if (applications && applications.length > 0) {
      if (applications[0].message !== undefined) {
        dispatch({
          type: FETCH_APPLICATIONS_FAILURE,
          payload: applications[0].message,
        });
        return { error: applications[0].message };
      }
      
      const processedApplications = applications.map((app, index) => ({
        ...app,
        submissions: app.submissions,
        id: app.id || app.applicationId || index + 1,
        currentSubmission: app.submissions,
      }));
      
      dispatch({
        type: FETCH_APPLICATIONS_SUCCESS,
        payload: { status, applications: processedApplications },
      });
      
      return { success: true, data: processedApplications };
    } else {
      dispatch({
        type: FETCH_APPLICATIONS_SUCCESS,
        payload: { status, applications: [] },
      });
      return { success: true, data: [] };
    }
  } catch (error) {
    const errorMsg = error.message || "An error occurred";
    dispatch({
      type: FETCH_APPLICATIONS_FAILURE,
      payload: errorMsg,
      error,
    });
    return { error: errorMsg, errorObj: error };
  }
};

// Fetch counts for all statuses
export const fetchAllStatusCounts = () => async (dispatch) => {
  dispatch({ type: FETCH_ALL_COUNTS_REQUEST });
  
  const statusesToCheck = [
    "SUBMITTED_FOR_BETA",
    "APPROVED_FOR_BETA",
    "SUBMITTED_FOR_STAGING",
    "APPROVED_FOR_STAGING",
    "IN_REVIEW",
    "SUBMITTED_FOR_PRODUCTION",
    "APPROVED_FOR_PRODUCTION",
    "PUBLISHED",
    "GENERATING_DELTA",
    "DELISTED_BY_SELLER",
    "DELISTED_BY_ADMIN",
    "DELISTED_BY_APPROVER",
  ];

  try {
    const newCounts = {};
    const batchSize = 3;
    
    for (let i = 0; i < statusesToCheck.length; i += batchSize) {
      const batch = statusesToCheck.slice(i, i + batchSize);
      
      const batchPromises = batch.map(async (status) => {
        try {
          const response = await APIManager.getAllApplication(status);
          const uniqueAppIds = new Set();
          
          if (response && Array.isArray(response)) {
            response.forEach((app) => {
              if (app.id || app.applicationId) {
                uniqueAppIds.add(app.id || app.applicationId);
              }
            });
          }
          
          newCounts[status] = uniqueAppIds.size;
        } catch (error) {
          console.error(`Error fetching count for status ${status}:`, error);
          newCounts[status] = 0;
        }
      });
      
      await Promise.all(batchPromises);
      
      if (i + batchSize < statusesToCheck.length) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    }
    
    dispatch({
      type: FETCH_ALL_COUNTS_SUCCESS,
      payload: newCounts,
    });
    
    return newCounts;
  } catch (error) {
    dispatch({
      type: FETCH_ALL_COUNTS_FAILURE,
      payload: error.message,
    });
    return null;
  }
};

export const loadInitialData = (activeStatus) => async (dispatch, getState) => {
  dispatch({ type: LOAD_INITIAL_DATA_REQUEST });
  
  const safeActiveStatus = activeStatus || "SUBMITTED_FOR_PRODUCTION";
  
  try {
    // Fetch main data and counts in parallel
    const [applicationsResult, countsResult] = await Promise.all([
      dispatch(fetchApplicationsByStatus(safeActiveStatus)),
      dispatch(fetchAllStatusCounts()),
    ]);
    
    // Check for errors
    if (applicationsResult.error) {
      dispatch({
        type: LOAD_INITIAL_DATA_FAILURE,
        payload: applicationsResult.error,
      });
      return { error: applicationsResult.error, errorObj: applicationsResult.errorObj };
    }
    
    dispatch({
      type: LOAD_INITIAL_DATA_SUCCESS,
    });
    
    return { 
      success: true, 
      applications: applicationsResult.data,
      counts: countsResult 
    };
  } catch (error) {
    const errorMsg = error.message || "An error occurred during initial data load";
    dispatch({
      type: LOAD_INITIAL_DATA_FAILURE,
      payload: errorMsg,
    });
    return { error: errorMsg, errorObj: error };
  }
};

export const deleteApplication = (applicationId) => async (dispatch) => {
  dispatch({ type: DELETE_APPLICATION_REQUEST });
  
  try {
    await APIManager.deleteDeletedApplication(applicationId);
    
    dispatch({
      type: DELETE_APPLICATION_SUCCESS,
      payload: applicationId,
    });
    
    return { success: true };
  } catch (error) {
    const errorMsg = error.message || "Failed to delete application";
    dispatch({
      type: DELETE_APPLICATION_FAILURE,
      payload: errorMsg,
    });
    return { error: errorMsg };
  }
};

export const rejectDeleteRequest = (applicationId) => async (dispatch) => {
  dispatch({ type: REJECT_DELETE_REQUEST });
  
  try {
    await APIManager.rejectDeletedApplication(applicationId);
    
    dispatch({
      type: REJECT_DELETE_SUCCESS,
      payload: applicationId,
    });
    
    return { success: true };
  } catch (error) {
    const errorMsg = error.message || "Failed to reject delete request";
    dispatch({
      type: REJECT_DELETE_FAILURE,
      payload: errorMsg,
    });
    return { error: errorMsg };
  }
};